import React, { useEffect, useState } from 'react'
import { FormControl, InputLabel, FormHelperText, Select, MenuItem, Input } from '@material-ui/core'
import Surveys from '../../services/survey'

export default function MakeSurvey (props) {
  const [surveys, setSurveys] = useState([])

  useEffect(() => {
    Surveys.get({organizationId: props.organizationId})
      .then(result => {
        let filteredSurveys = result
          .filter(sur => sur.published)
          .filter(sur => !sur.programId || sur.id === props.surveyId)
          
        // for WhatsApp Programs, survey must have the WhatsApp templates set to use it
        if (props.communicationMethod === 'whatsapp') {
          filteredSurveys = filteredSurveys.filter(sur => sur.welcomeWhatsAppTemplateId && sur.reminderWhatsAppTemplateId)
        }

        setSurveys(filteredSurveys)

        console.log('MakeSurvey.getSurveys.filtered', props.communicationMethod, filteredSurveys)
      })
      .catch(err => {
        console.log('SurveySelector.getSurveys.error', err)
      })
  }, [props.organizationId, props.communicationMethod])

  const onSelect = (e) => {
    console.log('SurveySelector.onSelect', e.target.value)
    props.onChange(e.target.value)
  }
  
  return (
    <FormControl fullWidth margin='dense'>
      <InputLabel id="survey-selector-label">Survey</InputLabel>
      <Select
        labelId="survey-selector-label"
        id="survey-selector"
        value={props.surveyId || ''}
        onChange={onSelect}
        required
        disabled={props.disabled}
        input={<Input />}
      >
        <MenuItem value="">Select a survey</MenuItem>
        {surveys.map(survey => <MenuItem key={survey.id} value={survey.id}>{survey.name}</MenuItem>)}
      </Select>
      <FormHelperText>Select the survey you wish subscribers to participate in</FormHelperText>
    </FormControl>
  )
}